import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AdultCheck } from '../parentGate/AdultCheck';
import { AgePicker } from './AgePicker';
import { useProfileStore } from '../../store/profile';
import { settingsFor } from '../../store/ageSettings';
import { useProgressStore } from '../../store/progress';

/** Parent settings behind the adult check: age, pause reminder, sound. */
export const ParentSettingsPage: React.FC = () => {
  const navigate = useNavigate();
  const [unlocked, setUnlocked] = useState(false);
  const profile = useProfileStore((s) => s.profile);
  const setAgeBand = useProfileStore((s) => s.setAgeBand);
  const setPauseReminder = useProfileStore((s) => s.setPauseReminder);
  const muted = useProgressStore((s) => s.muted);
  const setMuted = useProgressStore((s) => s.setMuted);

  if (!unlocked) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-[#8ecae6] to-[#669bbc]">
        <AdultCheck onPass={() => setUnlocked(true)} onCancel={() => navigate('/')} />
      </div>
    );
  }

  const perSession = settingsFor(profile?.ageBand).levelsPerSession;

  return (
    <div
      className="min-h-screen bg-gradient-to-b from-[#8ecae6] via-[#A8D8EA] to-[#669bbc] px-4 py-8"
      data-name="parent-settings"
    >
      <div className="mx-auto max-w-4xl">
        <div className="mb-6 flex flex-wrap items-center justify-between gap-4">
          <h1 className="font-display text-4xl font-bold text-white drop-shadow">For voksne</h1>
          <button
            type="button"
            onClick={() => navigate('/')}
            className="min-h-[72px] rounded-2xl bg-white px-8 font-display text-xl font-bold text-[#6441A5] shadow"
          >
            Ferdig
          </button>
        </div>

        <h2 className="font-display text-2xl font-bold text-white mb-3">Barnets alder</h2>
        <AgePicker selected={profile?.ageBand ?? null} onPick={setAgeBand} />

        <div className="mt-8 grid gap-4 sm:grid-cols-2">
          <label className="flex items-center gap-4 rounded-2xl bg-white/95 p-5 shadow">
            <input
              type="checkbox"
              data-name="pause-reminder"
              className="h-8 w-8"
              checked={profile?.pauseReminder !== false}
              onChange={(e) => setPauseReminder(e.target.checked)}
            />
            <span className="font-body text-gray-700">
              <b className="font-display text-lg">Pause etter {perSession} nivåer</b>
              <br />
              Bilen «sover i garasjen» – en rolig avslutning.
            </span>
          </label>
          <label className="flex items-center gap-4 rounded-2xl bg-white/95 p-5 shadow">
            <input
              type="checkbox"
              className="h-8 w-8"
              checked={!muted}
              onChange={(e) => setMuted(!e.target.checked)}
            />
            <span className="font-body text-gray-700">
              <b className="font-display text-lg">Lyd og stemme</b>
            </span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default ParentSettingsPage;
